import { setCookie } from 'cookies-next/client';

const cookieRedirectAfterAuthName = 'redirectAfterAuth';

export function setCookieRedirectAfterAuth(path: string) {
  setCookie(cookieRedirectAfterAuthName, path, { path: '/' });
}
